<template>
  <div class="custom-app-bar">
    <v-app-bar
      :color="MIXIN_getBgInfo(settings, 'color')"
      :height="hover && $route.name === 'BodyEdit' ? '80px' : '80px'"
      elevation="0"
      :app="$route.name === 'BodyEdit' ? false : true"
      :class="[{'imgBg': MIXIN_getBgInfo(settings, 'image')}]" 
      :style="`background-image: url(${MIXIN_getBgInfo(settings, 'image')}); width: 100%`"
     >
      <div :class="['div-style']" >
        <v-row
          :style="
            `
            max-width: ${$vuetify.breakpoint.mdAndUp ? '1340px' : ''}; 
            width: ${$vuetify.breakpoint.mdAndUp ? '100%' : '100vw'} !important
            `
          "
          justify="space-around"
          align="center"
          class="px-4"
        >
          <div>
            <v-img
              :max-width="130"
              :height="settings.logo_height"
              contain
              eager
              :src="settings.logo"
              @click="redirectToMainPage"
              style="cursor: pointer"
            ></v-img>
          </div>

          <div class="d-flex flex justify-end align-center">
            <section 
              v-if="$vuetify.breakpoint.mdAndUp" 
              class="d-flex flex justify-end align-center" 
              style="gap: 24px"
            >
              <div 
                v-for="(item, index) in settings.options" 
                :key="index"
              >
                <b>
                  <a
                    :href="item.destination === 'Link Externo' ? item.action : ''"
                    target="_blank"
                    v-if="item.style !== 'button' && item.destination === 'Link Externo'"
                    class="pointer"
                    :style="
                      `
                      text-decoration: none;
                      font-family: ${MIXIN_getStyle(settings, 'text', 'font')} !important; 
                      font-size: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important; 
                      color: ${MIXIN_getStyle(settings, 'text', 'color')} !important; 
                      line-height: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important; 
                      font-weight: ${MIXIN_getStyle(settings, 'text', 'weight')} !important;
                      font-style: ${MIXIN_getStyle(settings, 'text', 'font-style')} !important;
                      `
                    "                   
                  >
                    {{ item.caption }}
                  </a>
                </b>

                <b
                  v-if="item.style !== 'button' && item.destination !== 'Link Externo'"
                  @click="actionButton(item)"
                  class="pointer"
                  :style="
                    `
                    font-family: ${MIXIN_getStyle(settings, 'text', 'font')} !important; 
                    font-size: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important; 
                    color: ${MIXIN_getStyle(settings, 'text', 'color')} !important; 
                    line-height: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important; 
                    font-weight: ${MIXIN_getStyle(settings, 'text', 'weight')} !important;
                    font-style: ${MIXIN_getStyle(settings, 'text', 'font-style')} !important;
                    `
                  "                  
                  >
                  {{ item.caption }}
                </b>

                <v-btn
                  v-if="item.style === 'button'"
                  :href="item.destination === 'Link Externo' ? item.action : ''"
                  elevation="0"
                  min-width="155px"
                  target="_blank"
                  height="44px"
                  :style="
                    `
                    background-color: ${item.color || MIXIN_getStyle(settings, 'button', 'background-color')} !important;
                    border-radius: ${item['border-radius'] && item['border-radius'] !== '0' ? `${item['border-radius']}px` : MIXIN_getStyle(settings, 'button', 'border-radius')} !important;
                    `
                  "
                  @click="actionButton(item)"
                >
                  <b
                    :style="
                      `
                      color: ${item.textColor || MIXIN_getStyle(settings, 'button', 'color')} !important;
                      `
                    "
                    >
                    {{ item.caption }}
                    </b>
                </v-btn>
              </div>
            </section>

            <v-icon
              v-else
              size="22"
              :color="MIXIN_getStyle(settings, 'text', 'color')" 
              @click="drawer = true"
            >
              fa-regular fa-bars
            </v-icon>            
          </div>
        </v-row>
      </div>
    </v-app-bar>

    <v-navigation-drawer
      v-if="drawer"
      v-model="drawer"
      :color="MIXIN_getBgInfo(settings, 'color')"
      right
      fixed
      temporary
    >   
      <v-row no-gutters justify="end">
        <v-icon 
          class="mt-4 mr-4" 
          :color="MIXIN_getStyle(settings, 'text', 'color')" 
          size="20"
          @click="drawer = false"
        >
          fa-solid fa-xmark
        </v-icon>
      </v-row>

      <v-list v-if="settings">
        <v-list-item v-for="(item, index) in settings.options" :key="index">
          <v-row class="mt-4" justify="center" no-gutters>
            <b v-if="item.style !== 'button' && item.destination === 'Link Externo'">
              <a
                :href="item.destination === 'Link Externo' ? item.action : ''"
                target="_blank"
                :style="
                  `
                  text-decoration: none;
                  font-family: ${MIXIN_getStyle(settings, 'text', 'font')} !important; 
                  font-size: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important; 
                  color: ${MIXIN_getStyle(settings, 'text', 'color')} !important; 
                  line-height: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important; 
                  font-weight: ${MIXIN_getStyle(settings, 'text', 'weight')} !important;
                  font-style: ${MIXIN_getStyle(settings, 'text', 'font-style')} !important;
                  `
                " 
                class="pointer"
              >
                {{ item.caption }}
              </a>
            </b>
            
            <b
              v-else-if="item.style !== 'button' && item.destination !== 'Link Externo'"
              @click="actionButton(item)"
              :style="
                `
                font-family: ${MIXIN_getStyle(settings, 'text', 'font')} !important; 
                font-size: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important; 
                color: ${MIXIN_getStyle(settings, 'text', 'color')} !important; 
                line-height: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important; 
                font-weight: ${MIXIN_getStyle(settings, 'text', 'weight')} !important;
                font-style: ${MIXIN_getStyle(settings, 'text', 'font-style')} !important;
                `
              " 
              class="pointer"
              >
                {{ item.caption }}
            </b>

            <v-btn
              v-else
              :href="item.destination === 'Link Externo' ? item.action : ''"
              elevation="0"
              height="44px"
              :style="
                `
                overflow: hidden !important;
                max-width: 224px !important;
                background-color: ${item.color || MIXIN_getStyle(settings, 'button', 'background-color')} !important;
                border-radius: ${item['border-radius'] && item['border-radius'] !== '0' ? `${item['border-radius']}px` : MIXIN_getStyle(settings, 'button', 'border-radius')} !important;
                `
              "
              @click="actionButton(item)"
            >
              <div style="max-width: 80%; overflow: hidden; text-overflow: ellipsis">
                <b
                  :style="
                    `
                    color: ${MIXIN_getStyle(settings, 'button', 'color') || item.textColor} !important;
                    `
                  "
                >
                  {{ item.caption }}
                </b>
              </div>
            </v-btn>
          </v-row>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GetLayoutSectionMixin } from "../../mixins/GetLayoutSection"

export default {
  mixins: [GetLayoutSectionMixin], 
  props: {
    settings: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      drawer: false,
      hover: false,
      loading: false
    };
  },

  computed: {
    ...mapGetters(["infos", "oneCheckoutOpen"]),
  },


  methods: {
    closeAndScroll(item) {
      this.drawer = false;
      this.$vuetify.goTo(item);
    },

    actionButton(item) {
      try {
        if (item.action && item.action.charAt(0) === "#")
          this.$vuetify.goTo(item.action);
        else if (item.destination === "Abrir Checkout") {
          this.openCheckout();
        }
        else if (item.destination === 'Página') {
          const params = this.$route.params
          const page = this.infos.pages.find(page => page.id === item.action)
          const currentRoute = page.route.split('/')[1]

          if (page && currentRoute !== params.page) {
            this.$router.push({name: 'CustomBodyPage', params: {page: page.route.split('/')[1]}})
            this.$store.dispatch('setSelectedPage', item.action)
          }
        }
      } catch (e) {
        const params = this.$route.params
        this.$router.push({name: 'Body Version', params: {slug: params.slug, version: params.version}})
        setTimeout(() => {this.actionButton(item)})
      }
    },

    async openCheckout() {
      await this.$store.dispatch("setOneCheckoutOpen", true);
    },

    redirectToMainPage() {
      const params = this.$route.params
      if (!params.page) {
        window.scrollTo({top: 0, behavior: 'smooth'})
        return
      }

      if (this.$route.name === 'CustomBodyPage') {
        const mainPage = this.infos.pages.find(page => page.route === '/')
        if (mainPage) this.$store.dispatch('setSelectedPage', mainPage.id)
        this.$router.push({name: 'CustomBodyPage', params: {page: null}})
      }
    }
  },
};
</script>

<style scoped>
.menuEdit {
  z-index: 999 !important;
  position: absolute !important;
  top: 0;
}

.div-style {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-app-bar /deep/ .v-toolbar__content .v-toolbar__extension {
  padding: 0px !important
}

.imgBg {
  max-height: 100%;
  background-size: cover;
}
</style>
